// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2xAuB","messages":"Chat_messages__37yE0","dateDivider":"Chat_dateDivider__1GHVp"};